<template>
  <a-config-provider :autoInsertSpaceInButton="false" :locale="zhCN">
    <div class="wh100">
      <router-view></router-view>
    </div>
  </a-config-provider>
</template>
<script setup>
import { h , onMounted,getCurrentInstance} from 'vue'
import { Spin } from 'ant-design-vue'
// import { LoadingOutlined } from '@ant-design/icons-vue'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import blockIcon from '@/components/loading/blockLoading/index.vue'
const { proxy } = getCurrentInstance()
dayjs.locale('zh-cn')
Spin.setDefaultIndicator({  // loading的默认图标
  // indicator: h('div', { class: 'default-loading-icon' }, h(blockIcon)),
  // indicator: h(
  //   'div',
  //   {
  //     style: {
  //       display: 'inline-block',
  //       width: '100px',
  //       height: '100px'
  //     }
  //   },
  //   {
  //     default: () => h(blockIcon, { class: 'default-loading-icon' })
  //   }
  // ),
  indicator: h(blockIcon, { class: 'default-loading-icon', style: { width: '100px',  height: '100px' } })
  // h(LoadingOutlined),      // 小圆圈
})
</script>
<style lang="less">
.ant-spin-nested-loading {
  .ant-spin {
    .block-loading-wrapper.default-loading-icon {
      .alpha-loading-wrapper {
        position: relative;
        // 20px时父级的默认宽度， 平移一般即为10
        transform: translateX(-50%);
      }
    }
  }
}
</style>
